
import Vue from "vue";
import { Bar } from "vue-chartjs";

export default Vue.extend({
    extends: Bar,
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                            },
                        },
                    ],
                },
            },
        };
    },
    props: {
        datasets: Array,
        labels: Array,
    },
    computed: {
        chartdata() {
            return {
                labels: this.labels,
                datasets: this.datasets,
            };
        },
    },
    mounted() {
        this.renderChart(this.chartdata, this.options);
    },
});
